import { useMemo, type CSSProperties } from 'react'
import { deriveTheme, roleNames } from '@/content/theme'
import { usePrefs } from './prefs'

/**
 * Inline role overrides for an element that sets its own data-theme or
 * data-mission, so a custom palette reaches it too. Empty without one.
 */
export function useCustomRoles() {
  const { prefs } = usePrefs()
  const theme = useMemo(() => {
    if (!prefs.palette) return null
    const [primary, secondary, accent] = prefs.palette.split(',')
    return deriveTheme({ primary, secondary, accent })
  }, [prefs.palette])
  return (mode: 'light' | 'dark'): CSSProperties | undefined =>
    theme ? (Object.fromEntries(roleNames.map((name) => [`--mds-${name}`, theme[mode][name]])) as CSSProperties) : undefined
}
